import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { History } from 'history'

import { fetchConfigurations } from '../../actions/configurationActions'
import { selectConfigurationIndex } from '../../reducers/configurationReducer'
import { Configuration } from '../../core/types'
import Breadcrumb from '../../components/Breadcrumb'
import LoadingSection from '../../components/loadingSection'

export interface Props {
  configurations: Configuration[]
  location: { key: any } & Location
  history: History
  fetchConfigurations: () => Promise<any>
}

interface State {
  loading: boolean
}

export class ConfigurationIndex extends Component<Props, State> {
  state = { loading: true }

  componentDidMount() {
    this.loadConfigurations()
  }

  loadConfigurations = async () => {
    const { fetchConfigurations } = this.props
    this.setState({ loading: true })
    try {
      await fetchConfigurations()
    } finally {
      this.setState({ loading: false })
    }
  }

  render() {
    const { configurations } = this.props

    const levels = [
      { label: 'Index ', path: '/' },
      { label: 'Configurations', path: '/configuration' },
    ]

    return (
      <>
        <Breadcrumb levels={levels} />
        <LoadingSection isLoading={this.state.loading}>
          <div className="index index__drive-america">
            <h1 className="index-table__header">Configurations</h1>
            <div className="index-table__drive-america">
              <a
                href="/configuration/new"
                className="button button-drive-america link-drive-america link-drive-america__new-applicant"
              >
                New Configuration
              </a>
            </div>
            <table className="index-table">
              <tbody className="index-table__body">
                {configurations.map((configuration) => (
                  <tr
                    key={configuration.id}
                    className="index-table__row"
                    onClick={() =>
                      this.props.history.push(
                        `/configuration/${configuration.id}`
                      )
                    }
                  >
                    <td className="index-table__cell">
                      {configuration.callCenterName}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </LoadingSection>
      </>
    )
  }
}

export const mapStateToProps = (state) => {
  return {
    configurations: selectConfigurationIndex(state.configurations),
  }
}

export default withRouter(
  connect(mapStateToProps, { fetchConfigurations })(ConfigurationIndex)
)
